import React, { useRef, useEffect, useContext, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputNumber } from 'primereact/inputnumber';
import { Toast } from 'primereact/toast';
import '../layout/sass/_pickListSugestoes.scss'
import '../layout/sass/_responsiveTable.scss'
import {AuthContext} from '../contexts/AuthContext';
import { confirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';
import api from '../api/api';

export const TabelaLojaItens = ({ lojaItens, setLojaItens, isEditing, getLojaItens, defaultValues }) => {
    const toast = useRef(null);
    const confirmationToast = useRef(null)
    const [isDeleting, setIsDeleting] = useState(false);
    const { user } = useContext(AuthContext);

    const codigoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Código</span>
                    <span className="table-data">{rowData.id}</span>
                </p>
            </React.Fragment>
        );
    }

    const municipioBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Municipio</span>
                    <span className="table-data">{rowData.municipioNome}</span>
                </p>
            </React.Fragment>
        );
    }

    const produtoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Nome do Produto</span>
                    <span className="table-data">{rowData.produtoNome}</span>
                </p>
            </React.Fragment>
        );
    }

    const quantidadeBodyTemplate = (rowData) => {

        return (
            <React.Fragment>
                <p style={{textalign: 'left'}}>
                    <span className="p-column-title">Quantidade</span>
                    <InputNumber onValueChange={(e) => handleEditQuantidade(rowData,e)} value={rowData.quantidade} />

                </p>
            </React.Fragment>
        );
     }

     const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-trash" type="button" className="p-button-rounded p-mr-2 p-button-danger" loading={isDeleting} onClick={() => handleDeleteClick(rowData)}/>
            
            </div>
        );
    }

    const handleEditQuantidade = async (data,e) => {
        const temp = {
            "id": data.id,
            "quantidade": e.target.value,
        }
        try {
            if (isEditing) {
                api.put("lojaitens/updateQtde", temp)
                defaultValues.itens.forEach(i => {
                    if (i.id === data.id)
                    {
                        i.quantidade = e.target.value;
                    }
                    
                });  
                toast.current.show({ life: 2000, severity: 'success', summary: 'Quantidade Atualizada!', detail: `${data.produtoNome} alterado com sucesso` });
            }
            else
            {
                lojaItens.forEach(i => {
                    if (i.produtoId === data.produtoId)
                    {
                        i.quantidade = e.target.value;
                    }
                    
                });    
            }
        }
        catch (error) {

            toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao alterar!', detail: "Erro ao alterar..." });

        }

    }

    useEffect(() => {

    }, [lojaItens]);

    const onRowEditComplete1 = (e) => {
        let lojaItens2 = [...lojaItens];
        let { newData, index } = e;

        lojaItens2[index] = newData;

        setLojaItens(lojaItens2);
    }

    const handleDeleteClick = (data) => {

        data['userEmail'] = user.email

        confirmDialog({
            message: `Você tem certeza que quer remover esse item?`,
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: async () => {
                setIsDeleting(true);

                try {
                    await api.delete(`lojaitens/${data.id}`);     
                    getLojaItens();
                    toast.current.show({ life: 5000, severity: 'success', summary: 'Remoção concluída!', detail: `Item removido com sucesso` });
                }
                catch (error) {
                    toast.current.show({ life: 5000, severity: 'error', summary: 'Erro ao remover item', detail: error.response.data });
                }

                setIsDeleting(false);
            },
            reject: () => { return }
        });
    }

    return (

        <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">
            <Toast ref={toast} position="bottom-right" />

            <Toast ref={confirmationToast} position="bottom-center" />

            <div className="card p-col-12 datatable-responsive-demo">

                <div className="p-fluid">

                    <DataTable style={{width: "100%"}}

                        editMode="row"
                        onRowEditComplete={onRowEditComplete1}
                        responsiveLayout="scroll"
                        value={lojaItens}
                        className="p-datatable-responsive-demo"
                        emptyMessage="Nenhuma item da loja encontrado"
                        dataKey="id"
                        paginator
                        rows={10}
                        currentPageReportTemplate="Mostrando de {first} a {last} de {totalRecords} itens da loja"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        rowsPerPageOptions={[10, 20, 30]}
                        sortField="nome"
                        sortOrder={1}
                        removableSort
                    >

                        {isEditing ?
                            <Column style={{width: "10%"}}
                                field="id"
                                header="Código"
                                sortable
                                body={codigoBodyTemplate}

                            />
                            :
                            <></>
                        }

                        <Column style={!isEditing ? {width: "40%"} : {width: "30%"}}
                            field="municipio"
                            header="Municipio"
                            sortable
                            body={municipioBodyTemplate}

                        />

                        <Column style={!isEditing ? {width: "40%"} : {width: "30%"}}
                            field="produtoNome"
                            header="Nome do Produto"
                            sortable
                            body={produtoBodyTemplate}

                        />

                        <Column style={{ width: '20%' }}
                            field="quantidade"
                            header="Quantidade"
                            body={quantidadeBodyTemplate}
                            >

                        </Column>

                        {isEditing ?
                        <>
                        <Column
                            header="Ações"
                            body={actionBodyTemplate}
                            />
                        </>
                            :
                            <></>
                        }
                        
                    </DataTable>

                </div>
            </div>
        </div>
    );
}
